export default __webpack_public_path__ + "static/media/default-classroom-image.f0e04724.svg";